import { ApiConstants } from '../constants/api';
import { callToast, isApiSuccess, createFormData, getCookie} from '../service/Utilities'
import { buildUrlEncodedBody, makeApiRequest } from './TeamsApi';
// import axios from 'axios';

export async function callLoginApi(login, password) {
  let authString = `${login}:${password}`;
  let headers = new Headers();
  headers.set("Authorization", "Basic " + btoa(authString));
  const response = await fetch(ApiConstants.AUTH_ACCESS_TOKEN, {
    method: "POST",
    cache: "no-cache",
    headers,
  });
  // const response = await axios({
  //   method: 'post',
  //   url: ApiConstants.AUTH_ACCESS_TOKEN,
  //   headers
  // });
  return response.json();
}

function createUniqueHash(url, token) {
  return `key_${encodeURIComponent(url)}_${encodeURIComponent(token)}`;
}

let abortControllers = {};

export async function callApi({
  method = "GET",
  url = "",
  data = "",
  token = "",
  isFormdata = false,
  files = [],
  type = "json",
} = {}) {

  const key = createUniqueHash(url, token);

  // console.log(key)
  const excludedUrls = [ApiConstants.FOLDER_CLOSE_OPEN,ApiConstants.FOLDER_DETAIL,ApiConstants.FEED_INFO,ApiConstants.FEED_DELETE ,ApiConstants.SUBSCRIPTION_INFO,ApiConstants.USER_PREF,ApiConstants.USER_PREF_UPDATE,ApiConstants.RECENTLY_READ]
  
  if(abortControllers[key] && !excludedUrls.includes(url)){
    abortControllers[key].abort();
  }
  
  const controller = new AbortController();
  abortControllers[key] = controller;

  let headers = new Headers();
  if (!isFormdata) {
    headers.set("Content-Type", "application/x-www-form-urlencoded");
  }
  if (!!token) {
    headers.set("Authorization", token);
  }
  let settings = {
    method,
    cache: "no-cache",
    headers,
    signal:controller.signal
  };
  if (!!data) {
    let params;
    if (isFormdata) {
      params = new FormData();
      // console.log('data', data)
      Object.entries(data).map(([key, value]) => {
        createFormData(params, key, value, files);
      });
    } else {
      params = Object.keys(data)
        .map(function (k) {
          return encodeURIComponent(k) + "=" + encodeURIComponent(data[k]);
        })
        .join("&");
    }
    if (method.toUpperCase() == "POST" || method.toUpperCase() == "DELETE") {
      // settings.body = JSON.stringify(data);
      settings.body = params;
    } else {
      url += "?" + params;
    }
  }
  try{
    const response = await fetch(url, settings);
    if (!response.ok && !response.status) {
      throw {isErrorResponse:true,response};
    }
    if (type == "json") {
      return response.json();
    }
    if (type == "blob") {
      return response.blob();
    } else {
      return response;
    }
  }
  catch (error) {
    if (error.name === "AbortError") {
      // console.log(error)
      // let res = error.response;
      // res.response.status = 416;
      return {status:416,cancelError:true};
      // console.log(error.name)
      // console.log("Request was aborted",error);
      // throw new Error(response);
      // Optionally:
      // return null;
      // or throw a custom error
    }else if(error.isErrorResponse){
      throw error.response;
    }
  }
  finally{
    delete abortControllers[key];
  }
}

export const getFeedInfo = ({ feed_id, token }) =>
  new Promise((resolve, reject) => {
    const apiData = {
      url: ApiConstants.FEED_INFO,
      token,
      data: {
        site_id: feed_id,
      },
    };
    callApi(apiData).then((res) => {
      if (isApiSuccess(res.status)) {
        resolve(res.data);
      } else {
        if (res.msg) {
          callToast({ type: "error", msg: res.msg });
        }
      }
    });
    // .catch(error => {
    //     console.error('Error:', error);
    // });
  });

export const getSuggestion = ({ query, filter = "", token }) =>
  new Promise((resolve, reject) => {
    const apiData = {
      url: ApiConstants.SUGGESTION,
      token,
      data: {
        q: query,
        type: filter,
      },
    };
    callApi(apiData).then((res) => {
      if (isApiSuccess(res.status)) {
        resolve(res.data);
      } else {
        if (res.msg) {
          callToast({ type: "error", msg: res.msg });
        }
      }
    });
    // .catch(error => {
    //     console.error('Error:', error);
    // });
  });


  export const updateEventPref = ({event='',value='',token}) => 
    new Promise((resolve,reject) => {
      const apiData = {
        url:ApiConstants.UPDATE_EVENT_PREF,
        token,
        method:"POST",
        data: {
          ekey:event,
          evalue:value,
        }
      }

      callApi(apiData).then((res) => {
        if(isApiSuccess(res.status)){
          resolve();
          if(process.env.MODE != "production"){
            console.log("Event_Updated =>",{event,value});
          }
        }
      })
      .catch((error)=>{
        console.error(error);
      })
    })


export const getSpotlight = ({ q, mode, feed_id = "", token }) =>
  new Promise((resolve, reject) => {

    const apiData = {
      url: ApiConstants.SPOTLIGHT_LIST,
      token,
      data: {
        q,
        type: mode,
        site_id: feed_id,
      },
    };
    
    
    callApi(apiData).then((res) => {
      if (isApiSuccess(res.status)) {
        resolve(res.data);
      } else {
        if (res.msg) {
          callToast({ type: "error", msg: res.msg });
        }
      }
    });
    // .catch(error => {
    //     console.error('Error:', error);
    // });
  });

export const getSpotlightDefault = ({ token }) =>
  new Promise((resolve, reject) => {
    const apiData = {
      // url: ApiConstants.SPOTLIGHT_DEFAULT,
      url: ApiConstants.SPOTLIGHT_DEFAULT_NEW,
      token,
      // data: {
      //   q,
      //   type: mode,
      //   site_id: feed_id
      // }
    };
    callApi(apiData).then((res) => {
      if (isApiSuccess(res.status)) {
        resolve(res.data);
      } else {
        if (res.msg) {
          callToast({ type: "error", msg: res.msg });
        }
      }
    });
    // .catch(error => {
    //     console.error('Error:', error);
    // });
  });

export const getFolderDetail = ({ folder_id, followers = 0, token }) =>
  new Promise((resolve, reject) => {
    const apiData = {
      url: ApiConstants.FOLDER_DETAIL,
      token,
      data: {
        folder_id,
        followers,
      },
    };
    callApi(apiData).then((res) => {
      if (isApiSuccess(res.status)) {
        resolve(res.data);
      } else {
        if (res.msg) {
          callToast({ type: "error", msg: res.msg });
        }
      }
  })
  // .catch(error => {
  //     console.error('Error:', error);
  // });
});

export const getTeamFolderDetail = async ({folder_id,token}) => {
  const url =ApiConstants.FOLDER_GET_FEEDS;
  const params = {
    folder_id
  }
  const body = buildUrlEncodedBody(params);
  return makeApiRequest(url,"POST",token,body)
  .then((res) => {
    if(isApiSuccess(res.status)){
      return res.data;
    }else{
      callToast({type:"error",msg:res.msg})
      return [];
    }
  })
  .catch((error) => {
    callToast({type:"error",msg:error})
  })
}

export const getFolderEntries = async ({limit=25,sort="asc",folder_id="",feed_entry_created="",feed_entry_id="",token,feed_id="",unread}) => {
  const url = unread ==1 ? ApiConstants.FOLDER_GET_UNREAD: ApiConstants.FOLDER_GET_ARTICLES;
  const params = {
    limit,
    feed_entry_created,
    feed_entry_id,
    sort,
    mode:"moreajax",
    feedId:feed_id,
    folderId:folder_id
  }
  const body = buildUrlEncodedBody(params);
  return makeApiRequest(url,"POST",token,body)
  .then((res)=>{
    if(isApiSuccess(res.status)){
      return res.data
    }else{
      callToast({type:"error",msg:res.msg})
    }
  })
  .catch((error) => {
    callToast({type:"error",msg:error})
  })
} 

// export const getTeamFolderDetail =() => {
//   return 
// }

export const getAnnotated = (props) =>
  new Promise((resolve, reject) => {
    // console.log(props);
    const { token, limit = false, offset = false } = props;
    let data = {};
    data = limit ? { ...data, limit } : data;
    data = offset ? { ...data, offset } : data;

    const apiData = {
      url: ApiConstants.GET_NOTES,
      method: "GET",
      token,
      data,
    };
    callApi(apiData).then((res) => {
      if (isApiSuccess(res.status)) {
        let data = res.data;
        data.show_upgrade = res?.show_upgrade || false;
        resolve(data);
        resolve(data);
      } else {
        if (res.msg) {
          callToast({ type: "error", msg: res.msg });
        }
      }
    });
  });

  export const getSingleEntry = (entry_id,token) => new Promise((resolve, reject) => {
    let url = ApiConstants.ENTRIES
    let data = {
      entry_ids:entry_id
    }
    const apiData = {
      url,
      method:"GET",
      token,
      data,
    };

    callApi(apiData).then((res) => {
      if (isApiSuccess(res.status)) {
        resolve(res.data);
      } else {
        if (res.msg) {
          callToast({ type: "error", msg: res.msg });
        }
      }
    });
    
  })

export const getEntries = (props) =>
  new Promise((resolve, reject) => {
    // console.log('getEntries', props)
    const {
      limit = false,
      offset = false,
      feed_entry_id: entry_id = false,
      feed_entry_created: entry_created = false,
      feed_id: site_id = false,
      folder_id = false,
      tag_id = false,
      pinboard_id = false,
      sort = false,
      unread = 0,
      starred = 0,
      shared = 0,
      pinboard = 0,
      podcast = 0,
      search = false,
      entry_ids = false,
      token,
      method = "GET",
      teamsPinboard = 0,
      recently_read = 0
    } = props;

  let url = ApiConstants.ENTRIES;
  let data = {};
  data = limit ? { ...data, limit} : data;
  data = offset ? { ...data, offset} : data;
  data = entry_id ? { ...data, entry_id} : data;
  data = entry_created ? { ...data, entry_created} : data;
  data = site_id ? { ...data, site_id} : data;
  data = folder_id ? { ...data, folder_id} : data;
  data = pinboard_id ? { ...data, pinboard_id} : data;
  data = tag_id ? { ...data, tag_id} : data;
  data = sort ? { ...data, sort} : data;
  // data = unread ? { ...data, unread} : data;
  // data = starred ? { ...data, starred} : data;
  if(recently_read){
      data = {...data,mode:'recently_read'};
    }
    else if(starred) {
    data = { ...data, mode:'starred'}
  }
  else if(pinboard) {
    data = { ...data, mode:'pinboard'}
  }
  else if(teamsPinboard){
    data = {...data, mode:'teams_pinboard'}
  }
  else if(unread) {
    data = { ...data, mode:'unread'}
  }
  else if(podcast) {
    data = { ...data, mode:'podcast'}
  }
  else if(!!search) {
    url = ApiConstants.SEARCH_SITES;
    data = { q:search, limit: data.limit,  offset: data.offset}
    // console.log('search data', data)
  }
  else {
    data = { ...data, mode:'all'}
  }
  data = shared ? { ...data, shared} : data;
  data = entry_ids ? { ...data, entry_ids} : data;

    // data = {...data, profession:1};

  // console.log('getEntries data', data)

    const apiData = {
      url,
      method,
      token,
      data,
    };

    callApi(apiData).then((res) => {
      if (isApiSuccess(res.status)) {
        let data = res.data;
        data.show_upgrade = res?.show_upgrade || false;
        resolve(data);
      } else {
        if (res.msg) {
          callToast({ type: "error", msg: res.msg });
        }
      }
    });
    // .catch(error => {
    //     console.error('Error:', error);
    // });
  });

export const shareApi = ({ entry_id, network_id, notbook_guid = 0, token }) =>
  new Promise((resolve, reject) => {
    const apiData = {
      url: ApiConstants.SHARE,
      token,
      method: "POST",
      data: {
        entry_id,
        network_id,
        notbook_guid: notbook_guid == 0 ? undefined : notbook_guid,
      },
    };
    callApi(apiData).then((res) => {
      if (isApiSuccess(res.status)) {
        callToast({ type: "success", msg: "Shared Successfully" });
        resolve(res);
      } else if ([421, 423, 425].includes(res.status)) {
        resolve(res);
      } else {
        if (res.msg) {
          callToast({ type: "error", msg: res.msg });
        }
        resolve(res);
      }
    });
    // .catch(error => {
    //     console.error('Error:', error);
    // });
  });

export const shareSaveAccountApi = ({ data, token }) =>
  new Promise((resolve, reject) => {
    const apiData = {
      url: ApiConstants.SHARE_SAVE_ACCOUNT,
      token,
      method: "POST",
      isFormdata: true,
      data,
    };

    callApi(apiData).then((res) => {
      if (isApiSuccess(res.status)) {
        callToast({ type: "success", msg: "Shared Successfully" });
      } else {
        if (res.msg) {
          callToast({ type: "error", msg: res.msg });
        }
      }
    });
    // .catch(error => {
    //     console.error('Error:', error);
    // });
  });

export const getSchedulerAccountsApi = ({ token,callRestrictionModal }) =>
  new Promise((resolve, reject) => {
    const apiData = {
      url: ApiConstants.SCHEDULER_ACCOUNT,
      token,
    };

    callApi(apiData)
      .then((res) => {
        if (isApiSuccess(res.status)) {
          resolve(res.data);
        } else {
          if(res.status === 425){
            callRestrictionModal(res);
            resolve();
          }
          else if(res.msg) {
            callToast({ type: "error", msg: res.msg });
          }
        }
      })
      .catch((error) => {
        console.error("Error:", error);
        reject(error);
      });
  });

export const postSchedulerApi = ({ data, token }) =>
  new Promise((resolve, reject) => {
    const apiData = {
      url: ApiConstants.SCHEDULER_POST,
      method: "POST",
      token,
      data,
    };

    callApi(apiData).then((res) => {
      if (isApiSuccess(res.status)) {
        callToast({ type: "success", msg: "Shared Successfully" });
        resolve();
      } else if (res.status == 463) {
        // if(res.msg) { callToast({type:"error",msg:res.msg}) }
        resolve({ msg: res?.msg || "Queue is not configured", url: res?.url });
      } else {
        if (res.msg) {
          callToast({ type: "error", msg: res.msg });
        }
        resolve();
      }
    });
    // .catch(error => {
    //     console.error('Error:', error);
    // });
  });

export const favoriteApi = ({ entry_id, add, showToast = false, token }) =>
  new Promise((resolve, reject) => {
    const apiData = {
      url: add ? ApiConstants.FAVORITE_ADD : ApiConstants.FAVORITE_REMOVE,
      method: add ? "POST" : "DELETE",
      token,
      data: {
        entry_id,
        // mode: add ? "favorite" : "favorited"
      },
    };

    callApi(apiData).then((res) => {
      if (isApiSuccess(res.status)) {
        if (showToast) {
          callToast({
            type: "success",
            msg: `${add ? "Added to" : "Removed from"} favorites`,
          });
        }
        resolve();
      } else {
        if (res.msg) {
          callToast({ type: "error", msg: res.msg });
        }
      }
    });
    // .catch(error => {
    //     console.error('Error:', error);
    //     reject(error)
    // });
  });

export const getTagsApi = ({ token }) =>
  new Promise((resolve, reject) => {
    const apiData = {
      url: ApiConstants.TAG_LIST,
      token,
    };

    callApi(apiData).then((res) => {
      if (isApiSuccess(res.status)) {
        resolve(res.data);
      } else {
        if (res.msg) {
          callToast({ type: "error", msg: res.msg });
        }
      }
    });
    // .catch(error => {
    //     console.error('Error:', error);
    //     reject(error)
    // });
  });

export const updatePasswordApi = ({ token, password }) =>
  new Promise((resolve, reject) => {
    const apiData = {
      url: ApiConstants.UPDATE_PASSWORD,
      method: "POST",
      token,
      data: { new_password: password },
    };

    callApi(apiData).then((res) => {
      if (isApiSuccess(res.status)) {
        callToast({ type: "success", msg: "Saved Successfully" });
        resolve();
      } else {
        if (res.msg) {
          callToast({ type: "error", msg: res.msg });
        }
      }
    });
    // .catch(error => {
    //     console.error('Error:', error);
    //     reject(error)
    // });
  });

// export const updateProfileApi = ({token, name, website,blog, youtube_channel, bio, image, new_password}) => new Promise((resolve, reject) => {
//     const apiData = {
//       url: ApiConstants.UPDATE_PROFILE,
//       method: "POST",
//       token,
//       data: { name, website,blog, youtube_channel, bio, image, new_password}
//     }

//     callApi(apiData)
//     .then(res => {
//         if(isApiSuccess(res.status)) {
//           callToast({type:"success",msg:"Saved Successfully"});
//           resolve();
//         }
//         else {
//             if(res.msg) { callToast({type:"error",msg:res.msg}) }
//         }
//     });
// });

export const getUserInfoApi = ({ token, mode = undefined }) =>
  new Promise((resolve, reject) => {
    const apiData = {
      url: ApiConstants.USER_INFO,
      token,
      data: { mode },
    };

    callApi(apiData).then((res) => {
      if (isApiSuccess(res.status)) {
        resolve(res.data);
      } else {
        if (res.msg) {
          callToast({ type: "error", msg: res.msg });
        }
      }
    });
  });

export const getDigestListApi = ({ token }) =>
  new Promise((resolve, reject) => {
    const apiData = {
      url: ApiConstants.DD_PREF,
      token,
    };

    callApi(apiData).then((res) => {
      if (isApiSuccess(res.status)) {
        resolve(res.data);
      } else {
        if (res.msg) {
          callToast({ type: "error", msg: res.msg });
        }
      }
    });
  });

export const updateDigestApi = ({ token, preference_type, value }) =>
  new Promise((resolve, reject) => {
    const apiData = {
      url: ApiConstants.DD_UPDATE,
      method: "POST",
      token,
      data: { preference_type, value },
    };

    callApi(apiData).then((res) => {
      if (isApiSuccess(res.status)) {
        callToast({ type: "success", msg: "Saved Successfully" });
        resolve();
      } else {
        if (res.msg) {
          callToast({ type: "error", msg: res.msg });
        }
      }
    });
  });

export const getPaymentsInfo = ({ token }) =>
  new Promise((resolve, reject) => {
    const apiData = {
      url: ApiConstants.SUBSCRIPTION_INFO,
      method: "GET",
      token,
      // data: { preference_type, value }
    };

    callApi(apiData).then((res) => {
      if (isApiSuccess(res.status)) {
        // callToast({type:"success",msg:"Saved Successfully"});
        resolve(res.data);
      } else {
        if (res.msg) {
          callToast({ type: "error", msg: res.msg });
        }
      }
    });
  });

  export const getPricingInfo = ({ token,mode="" }) =>
    new Promise((resolve, reject) => {
      const apiData = {
        url: ApiConstants.SUBSCRIPTION_INFO,
        method: "GET",
        token,
        data: { mode }
      };
  
      callApi(apiData).then((res) => {
        if (isApiSuccess(res.status)) {
          // callToast({type:"success",msg:"Saved Successfully"});
          resolve(res.data);
        } else {
          if (res.msg) {
            callToast({ type: "error", msg: res.msg });
          }
        }
      });
    });



export const updateEmailApi = ({ token, email }) =>
  new Promise((resolve, reject) => {
    const apiData = {
      url: ApiConstants.UPDATE_EMAIL,
      method: "POST",
      token,
      data: { email },
    };

    callApi(apiData).then((res) => {
      if (isApiSuccess(res.status)) {
        callToast({ type: "success", msg: res.msg });
        resolve(res.data);
      } else {
        if (res.msg) {
          callToast({ type: "error", msg: res.msg });
        }
      }
    });
  });

export const getBillingInfoApi = ({ token }) =>
  new Promise((resolve, reject) => {
    const apiData = {
      url: ApiConstants.ACCOUNT_BILLING,
      token,
    };

    callApi(apiData).then((res) => {
      if (isApiSuccess(res.status)) {
        resolve(res.data);
      } else {
        if (res.msg) {
          callToast({ type: "error", msg: res.msg });
        }
      }
    });
  });

export const getOpmlUrlApi = ({ token }) =>
  new Promise((resolve, reject) => {
    const apiData = {
      url: ApiConstants.OPML_EXPORT,
      token,
    };

    callApi(apiData).then((res) => {
      if (isApiSuccess(res.status)) {
        resolve(res.data);
      } else {
        if (res.msg) {
          callToast({ type: "error", msg: res.msg });
        }
      }
    });
  });

export const getOpmlImportApi = ({ reader_name, opml_file, token }) =>
  new Promise((resolve, reject) => {
    const apiData = {
      url: ApiConstants.OPML_IMPORT,
      token,
      method: "POST",
      isFormdata: true,
      files: ["opml_file"],
      data: {
        reader_name,
        opml_file,
      },
    };

    callApi(apiData).then((res) => {
      if (isApiSuccess(res.status)) {
        resolve(res.data);
      } else {
        if (res.msg) {
          callToast({ type: "error", msg: res.msg });
        }
        reject(new Error(res.msg));
      }
    });
  });

export const getOpmlStatusApi = ({ token }) =>
  new Promise((resolve, reject) => {
    const apiData = {
      url: ApiConstants.OPML_STATUS,
      token,
    };

    callApi(apiData).then((res) => {
      if (isApiSuccess(res.status)) {
        resolve(res.data);
      } else {
        if (res.msg) {
          callToast({ type: "error", msg: res.msg });
        }
      }
    });
  });

export const getDDPrefApi = ({ token }) =>
  new Promise((resolve, reject) => {
    const apiData = {
      url: ApiConstants.DD_PREF,
      token,
    };

    callApi(apiData).then((res) => {
      if (isApiSuccess(res.status)) {
        resolve(res.data);
      } else {
        if (res.msg) {
          callToast({ type: "error", msg: res.msg });
        }
      }
    });
  });

export const updateDDPrefApi = ({ token, key, value }) =>
  new Promise((resolve, reject) => {
    const apiData = {
      url: ApiConstants.DD_UPDATE,
      token,
      method: "POST",
      data: { key, value },
    };

    callApi(apiData).then((res) => {
      if (isApiSuccess(res.status)) {
        resolve(res.data);
      } else {
        if (res.msg) {
          callToast({ type: "error", msg: res.msg });
        }
      }
    });
  });

export const teamAddApi = ({ token, name, email,callRestrictionModal }) =>
  new Promise((resolve, reject) => {
    const apiData = {
      url: ApiConstants.TEAM_ADD,
      token,
      method: "POST",
      data: { name, email },
    };

    callApi(apiData).then((res) => {
      if (isApiSuccess(res.status)) {
        resolve(res.data);
      }else if(res.status == 425){
        if(callRestrictionModal){
          callRestrictionModal(res);
        }
      } else {
        if (res.msg) {
          callToast({ type: "error", msg: res.msg });
        }
      }
    });
  });

export const teamRemoveApi = ({ token, member_id }) =>
  new Promise((resolve, reject) => {
    const apiData = {
      url: ApiConstants.TEAM_REMOVE,
      token,
      method: "DELETE",
      data: { member_id },
    };

    callApi(apiData).then((res) => {
      if (isApiSuccess(res.status)) {
        resolve(res.data);
      } else {
        if (res.msg) {
          callToast({ type: "error", msg: res.msg });
        }
      }
    });
  });

export const teamListApi = ({ token }) =>
  new Promise((resolve, reject) => {
    const apiData = {
      url: ApiConstants.TEAM_LIST,
      token,
    };

    callApi(apiData).then((res) => {
      if (isApiSuccess(res.status)) {
        resolve(res.data);
      } else {
        if (res.msg) {
          callToast({ type: "error", msg: res.msg });
        }
      }
    });
  });

export const getNavbarSearch = ({ q, limit = undefined, token }) =>
  new Promise((resolve, reject) => {
    const apiData = {
      url: ApiConstants.SEARCH_NAVBAR,
      token,
      data: {
        q,
        limit,
      },
    };
    callApi(apiData).then((res) => {
      if (isApiSuccess(res.status)) {
        resolve(res.data);
      } else {
        if (res.msg) {
          callToast({ type: "error", msg: res.msg });
        }
      }
    });
    // .catch(error => {
    //     console.error('Error:', error);
    // });
  });

export const getPodcastBrowseApi = ({
  category_name = undefined,
  limit = undefined,
  token,
}) =>
  new Promise((resolve, reject) => {
    const apiData = {
      url: ApiConstants.PODCAST_BROWSE,
      token,
      data: {
        // category_name ,
        limit,
      },
    };
    callApi(apiData).then((res) => {
      if (isApiSuccess(res.status)) {
        resolve(res.data);
      } else {
        if (res.msg) {
          callToast({ type: "error", msg: res.msg });
        }
      }
    });
    // .catch(error => {
    //     console.error('Error:', error);
    // });
  });

export const getPodcastCategoryListApi = ({ token }) =>
  new Promise((resolve, reject) => {
    const apiData = {
      url: ApiConstants.PODCAST_CAT_LIST,
      token,
      data: {
        // q ,
        // limit
      },
    };
    callApi(apiData).then((res) => {
      if (isApiSuccess(res.status)) {
        resolve(res.data);
      } else {
        if (res.msg) {
          callToast({ type: "error", msg: res.msg });
        }
      }
    });
    // .catch(error => {
    //     console.error('Error:', error);
    // });
  });

export const getPodcastCategoryFoldersApi = ({ category_name, token }) =>
  new Promise((resolve, reject) => {
    const apiData = {
      url: ApiConstants.PODCAST_CAT_DETAIL,
      token,
      data: {
        category_name,
      },
    };
    callApi(apiData).then((res) => {
      if (isApiSuccess(res.status)) {
        resolve(res.data);
      } else {
        if (res.msg) {
          callToast({ type: "error", msg: res.msg });
        }
      }
    });
    // .catch(error => {
    //     console.error('Error:', error);
    // });
  });

export const getPodcastRecommendedApi = ({ folder_id, site_id, token }) =>
  new Promise((resolve, reject) => {
    const apiData = {
      url: ApiConstants.PODCAST_RECOMMENDED,
      token,
      data: {
        folder_id,
        site_id,
      },
    };
    callApi(apiData).then((res) => {
      if (isApiSuccess(res.status)) {
        resolve(res.data);
      } else {
        if (res.msg) {
          callToast({ type: "error", msg: res.msg });
        }
      }
    });
    // .catch(error => {
    //     console.error('Error:', error);
    // });
  });

export const getOragnizeListApi = ({ folder_id = undefined, token,mode=undefined}) =>
  new Promise((resolve, reject) => {
          let data = {};

      if (!!folder_id && folder_id > 0) {
          data.folder_id = folder_id;
      }

      if (!!mode && mode === "rssbuilder") {
          data.mode = mode;
      }
    const apiData = {
      url: ApiConstants.ORGANIZE_LIST,
      token,
      data
    };
    callApi(apiData).then((res) => {
      if (isApiSuccess(res.status)) {
        resolve(res.data);
      } else {
        if (res.msg) {
          callToast({ type: "error", msg: res.msg });
        }
      }
    });
    // .catch(error => {
    //     console.error('Error:', error);
    // });
  });

export const getIndustryPackagesListApi = ({ token }) =>
  new Promise((resolve, reject) => {
    const apiData = {
      url: ApiConstants.INDUSTRY_LIST,
      token,
    };
    callApi(apiData).then((res) => {
      if (isApiSuccess(res.status)) {
        resolve(res.data);
      } else {
        if (res.msg) {
          callToast({ type: "error", msg: res.msg });
        }
      }
    });
    // .catch(error => {
    //     console.error('Error:', error);
    // });
  });

export const getIndustryPackagesFeaturesApi = ({ token }) =>
  new Promise((resolve, reject) => {
    const apiData = {
      url: ApiConstants.INDUSTRY_FEATURES,
      token,
    };
    callApi(apiData).then((res) => {
      if (isApiSuccess(res.status)) {
        resolve(res.data);
      } else {
        if (res.msg) {
          callToast({ type: "error", msg: res.msg });
        }
      }
    });
    // .catch(error => {
    //     console.error('Error:', error);
    // });
  });

export const getDeactivateAccountApi = ({ reason = "", notes = "", token }) =>
  new Promise((resolve, reject) => {
    const apiData = {
      url: ApiConstants.ACCOUNT_DEACTIVATE,
      token,
      method: "DELETE",
      data: {
        reason,
        notes,
      },
    };
    callApi(apiData).then((res) => {
      // console.log('getDeactivateAccountApi', res)
      if (isApiSuccess(res.status)) {
        callToast({
          type: "success",
          msg: "Deactivating Account... Kindly Wait...",
        });
        resolve(res.data);
      } else {
        if (res.msg) {
          callToast({ type: "error", msg: res.msg });
        }
      }
    });
    // .catch(error => {
    //     console.error('Error:', error);
    // });
  });

export const getHistoryAccountApi = ({url="", token}) => new Promise((resolve, reject) => {

  const apiData = {
      url: ApiConstants.ACCOUNT_HISTORY,
      token,
      method: "POST",
      data: {
        url,
      },
    };
    callApi(apiData).then((res) => {
      // console.log('getDeactivateAccountApi', res)
      if (isApiSuccess(res.status)) {
        // callToast({type:"success",msg:"Deactivating Account... Kindly Wait..."})
        resolve(res.data);
      } else {
        if (res.msg) {
          callToast({ type: "error", msg: res.msg });
        }
      }
    });
    // .catch(error => {
    //     console.error('Error:', error);
    // });
  });

export const getInvoiceListApi = ({ token }) =>
  new Promise((resolve, reject) => {
    const apiData = {
      url: ApiConstants.INVOICE_LIST,
      token,
      method: "GET",
    };
    callApi(apiData).then((res) => {
      if (isApiSuccess(res.status)) {
        resolve(res.data);
      } else {
        if (res.msg) {
          callToast({ type: "error", msg: res.msg });
        }
      }
    });
  });

export const downloadInvoiceApi = ({ invoice_id, token }) =>
  new Promise((resolve, reject) => {
    const apiData = {
      url: ApiConstants.INVOICE_DOWNLOAD,
      token,
      method: "GET",
      data: {
        invoice_id,
      },
    };
    callApi(apiData).then((res) => {
      if (isApiSuccess(res.status)) {
        resolve(res.data);
      } else {
        if (res.msg) {
          callToast({ type: "error", msg: res.msg });
        }
      }
    });
  });

export const getSubscriptionModalInfo = ({ token }) =>
  new Promise((resolve, reject) => {
    const apiData = {
      url: ApiConstants.SUBSCRIPTION_MODAL_INFO,
      token,
      method: "GET",
      // data: {
      //   invoice_id
      // }
    };
    callApi(apiData).then((res) => {
      if (isApiSuccess(res.status)) {
        resolve(res.data);
      } else {
        if (res.msg) {
          callToast({ type: "error", msg: res.msg });
        }
      }
    });
  });

export const getCheckoutSessionInfo = ({ token, plan, trial_end = false }) =>
  new Promise((resolve, reject) => {
    const apiData = {
      url: ApiConstants.SUBSCRIPTION_CHECKOUT,
      method: "POST",
      token,
      data: {
        plan,
        trial_end,
      },
    };

    callApi(apiData).then((res) => {
      if (isApiSuccess(res.status)) {
        // callToast({type:"success",msg:"Saved Successfully"});
        resolve(res.data);
      } else {
        if (res.msg) {
          callToast({ type: "error", msg: res.msg });
        }
      }
    });
  });


  export const folderState = async({
    change_to,
    folder_id,
    token
  }) => new Promise((resolve,reject) => {
    // console.log(change_to,folder_id,token)
    const apiData = {
      url:ApiConstants.FOLDER_CLOSE_OPEN,
      token,
      method:"POST",
      data: {
      change_to,
      folder_id}
    }
    callApi(apiData)
    .then((res) => {
      if (isApiSuccess(res.status)) {
        // console.log(res)
        resolve(res.data);
      } else {
        // callToast({ type: "error", msg: res.msg });
        console.error(res.msg)
        return null;
      }
    })
    .catch((error) => {
      console.error(error);
    });
  })

export const getHtml = async ({
  token,
  feed_url = "",
  mode = "data",
}) =>
  new Promise((resolve, reject) => {
    const apiData = {
      url: ApiConstants.GET_HTML,
      token,
      method: "GET",
      data: {
        feed_url: `${feed_url}`,
        mode,
      },
    };
    callApi(apiData)
      .then((res) => {
        if (isApiSuccess(res.status)) {
          // console.log(res)
          resolve(res.data);
        } else {
          // callToast({ type: "error", msg: res.msg });
          resolve(null);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  });

  export const isFeedInFolder = async ({ token,feed_id }) =>
    new Promise((resolve, reject) => {
      const apiData = {
        url: ApiConstants.IS_FEED_IN_FOLDER,
        token,
        method: "GET",
        data: {
          feed_id
        }
      };
      callApi(apiData).then((res) => {
        if (isApiSuccess(res.status)) {
          resolve(res.data);
        } else {
          if (res.msg) {
            callToast({ type: "error", msg: res.msg });
          }
        }
      });
    });

    export const sendLog = async  ({token, query, feature=2}) => new Promise((resolve,reject) => {
      const apiData = {
        url: ApiConstants.FEAT_LOG,
        token,
        method: "POST",
        data: {
          query,
          feature
        }
      };
      callApi(apiData).then((res) => {
        if (isApiSuccess(res.status)) {
          resolve();
        } 
      })
      .catch((error) => {
        callToast({ type: "error", msg: error } )
      });
    })


 export const exploreData = async ({ token,category }) => new Promise((resolve, reject) => {
    const apiData = {
      url: ApiConstants.EXPLORE_DATA,
      token,
      method: "GET",
      data: {
        category
      }
    };
    callApi(apiData).then((res) => {
      if (isApiSuccess(res.status)) {
        resolve(res.data);
      } else {
        if (res.msg) {
          callToast({ type: "error", msg: res.msg });
        }
      }
    });
  });


   export const reccBoxData = ({ token,mode='',limit=20,except_feed_ids='',offset=0,random_feed_id=''}) => new Promise((resolve, reject) => {
    const apiData = {
      url: ApiConstants.RECC_BOX_DATA,
      token,
      method: "GET",
      data:{
        ...(mode === 1 ? {mode} : mode=='all' ? {limit,offset} : {limit,except_feed_ids,offset,random_feed_id})
      }
    };
    callApi(apiData).then((res) => {
      if (isApiSuccess(res.status)) {
        resolve(res.data);
      } else {
        if (res.msg) {
          callToast({ type: "error", msg: res.msg });
        }
        resolve([]);
      }
    });
  });

   export const newsLetterData = ({ token, except_feed_ids='' }) => new Promise((resolve, reject) => {
    const apiData = {
      url: ApiConstants.NEWSLETTER_DATA,
      token,
      method: "GET",
      data:{
        except_feed_ids
      }
    };
    callApi(apiData).then((res) => {
      if (isApiSuccess(res.status)) {
        resolve(res.data);
      } else {
        if (res.msg) {
          callToast({ type: "error", msg: res.msg });
        }
        resolve([]);
      }
    });
  });

  export const getWizardData = ({ token,}) => new Promise((resolve, reject) => {
    const apiData = {
      url: ApiConstants.WIZARD_DATA,
      token,
      method: "GET",
    };
    callApi(apiData).then((res) => {
      if (isApiSuccess(res.status)) {
        resolve(res.data);
      } else {
        if (res.msg) {
          callToast({ type: "error", msg: res.msg });
        }
        resolve([]);
      }
    });
  });

  export const getSocialProfile = ({token,data}) => new Promise((resolve,reject) => {
      const apiData = {
        url:ApiConstants.SOCIAL_RSS_PROFILE,
        token,
        method:'GET',
        data
      }
      callApi(apiData).then((res) => {
        if(isApiSuccess(res.status) || res.status === 204){
          resolve(res.data);
        }else{
          if(res.msg){
            callToast({type:'error', msg: res.msg});
          }
          resolve(false)
        }
      })
  })

  export const socialProfileAdd = ({token,data}) => new Promise((resolve,reject) => {
    delete data.skey;
    delete data.posts;

    const apiData = {
      url:ApiConstants.SOCIAL_RSS_ADD,
      token,
      method:'POST',
      data
    }

    callApi(apiData).then((res) => {
      if(isApiSuccess(res.status)){
        resolve(true);
      }else if(res.status == 425){
        resolve(res);
      }else{
        if(res.msg){
          callToast({type:'error',msg:res.msg,autoClose:5000})
        }
        resolve(false);
      }
    })
  })

  export const markAsRecentlyRead = ({token,id}) => new Promise((resolve,reject) => {
    const apiData  = {
      url:ApiConstants.RECENTLY_READ,
      token,
      method:'POST',
      data:{id}
    }
    callApi(apiData).then((res) => {
      if(isApiSuccess(res.status)){
        resolve();
      }
    })
    .catch((error) => {
      callToast({type:'error', msg:error})
    })
  })

   export const autoFollowRss = ({token}) => new Promise((resolve,reject) => {
    const guest_id = getCookie('guestid');
    const apiData  = {
      url:ApiConstants.AUTO_FOLLOW,
      token,
      method:'POST',
      data:{guest_id}
    }
    callApi(apiData).then((res) => {
      if(isApiSuccess(res.status)){
        resolve();
      }
    })
    .catch((error) => {
      callToast({type:'error', msg:error})
    })
  })

export const runSavedSearch = ({ token, rule_id, offset } = {}) =>
  new Promise((resolve, reject) => {
    const data = { rule_id };
    if (offset != null) data.offset = offset;
    callApi({ method: 'POST', url: ApiConstants.SAVED_SEARCH_RUN, token, data })
      .then((res) => resolve(res))
      .catch((error) => reject(error));
  });

export const listSavedSearches = ({ token } = {}) =>
  new Promise((resolve, reject) => {
    callApi({ method: 'GET', url: ApiConstants.SAVED_SEARCH_LIST, token })
      .then((res) => resolve(res))
      .catch((error) => reject(error));
  });

export const renameSavedSearch = ({ token, rule_id, rule_title } = {}) =>
  new Promise((resolve, reject) => {
    callApi({ method: 'POST', url: ApiConstants.SAVED_SEARCH_UPDATE, token, data: { rule_id, rule_title } })
      .then((res) => resolve(res))
      .catch((error) => reject(error));
  });

export const deleteSavedSearch = ({ token, rule_id } = {}) =>
  new Promise((resolve, reject) => {
    callApi({ method: 'DELETE', url: ApiConstants.SAVED_SEARCH_DELETE, token, data: { rule_id } })
      .then((res) => resolve(res))
      .catch((error) => reject(error));
  });

export const listMyFeeds = ({ token } = {}) =>
  new Promise((resolve, reject) => {
    callApi({ method: 'GET', url: ApiConstants.MY_FEEDS, token })
      .then((res) => resolve(res))
      .catch((error) => reject(error));
  });

export const saveSearch = ({
  token,
  rule_title,
  keyword,
  scope,
  search_type,
  search_in,
  sort_by,
  sort_dir,
  start_date,
  end_date,
  language,
  feed_id,
  folder_id,
  exclude_words,
  filters,
  filter_match,
} = {}) =>
  new Promise((resolve, reject) => {
    const data = { keyword, rule_title };
    if (scope)         data.scope         = scope;
    if (search_type)   data.search_type   = search_type;
    if (search_in)     data.search_in     = search_in;
    if (sort_by)       data.sort_by       = sort_by;
    if (sort_dir)      data.sort_dir      = sort_dir;
    if (start_date)    data.start_date    = start_date;
    if (end_date)      data.end_date      = end_date;
    if (language)      data.language      = language;
    if (feed_id)       data.feed_id       = feed_id;
    if (folder_id)     data.folder_id     = folder_id;
    if (exclude_words) data.exclude_words = exclude_words;
    if (filter_match)  data.filter_match  = filter_match;
    if (filters && filters.length) {
      filters.forEach((f, i) => {
        data[`filters[${i}][field]`]     = f.field;
        data[`filters[${i}][condition]`] = f.condition;
        data[`filters[${i}][text]`]      = f.text;
      });
    }

    callApi({ method: 'POST', url: ApiConstants.SAVED_SEARCH_SAVE, token, data })
      .then((res) => resolve(res))
      .catch((error) => reject(error));
  });

export const searchInSites = ({
  token,
  keyword,
  scope,
  search_type,
  search_in,
  sort_by,
  sort_dir,
  start_date,
  end_date,
  language,
  feed_id,
  folder_id,
  exclude_words,
  filters,
  filter_match,
  offset,
} = {}) =>
  new Promise((resolve, reject) => {
    const data = { keyword };
    if (scope)         data.scope         = scope;
    if (search_type)   data.search_type   = search_type;
    if (search_in)     data.search_in     = search_in;
    if (sort_by)       data.sort_by       = sort_by;
    if (sort_dir)      data.sort_dir      = sort_dir;
    if (start_date)    data.start_date    = start_date;
    if (end_date)      data.end_date      = end_date;
    if (language)      data.language      = language;
    if (feed_id)       data.feed_id       = feed_id;
    if (folder_id)     data.folder_id     = folder_id;
    if (exclude_words) data.exclude_words = exclude_words;
    if (filter_match)  data.filter_match  = filter_match;
    if (offset != null) data.offset       = offset;
    if (filters && filters.length) {
      filters.forEach((f, i) => {
        data[`filters[${i}][field]`]     = f.field;
        data[`filters[${i}][condition]`] = f.condition;
        data[`filters[${i}][text]`]      = f.text;
      });
    }

    callApi({ method: 'POST', url: ApiConstants.GLOBAL_SEARCH, token, data })
      .then((res) => resolve(res))
      .catch((error) => reject(error));
  });